(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["button"] && !Shopify.designMode) return;
  try {
    (function() {
    document.addEventListener('DOMContentLoaded', () => {
      const links = document.querySelectorAll('a[data-ref-link]');
      const header = document.querySelector('header-component');
      const offset = header ? header.offsetHeight : 0;
      links.forEach(link => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const targetId = event.currentTarget.getAttribute('data-ref-link');
          const targetElement = document.querySelector(targetId);
          if (targetElement) {
            const topPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({
              top: topPosition,
              behavior: 'smooth'
            });
          }
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-swatches-content')) {
    class ProductSwatchesContent extends HTMLElement {
      constructor() {
        super();
        this._onChange = this._onChange.bind(this);
        this._onVariantEvent = this._onVariantEvent.bind(this);
        this._LABEL_SELECTOR = '[data-selected-swatch-label]';
        this._PICKER_SELECTOR = 'swatches-variant-picker-component';
        this._CHECKED_INPUT_SELECTOR = 'fieldset.variant-option--swatches input[type="radio"]:checked';
        this._SWATCH_INPUT_MATCH = 'input[type="radio"][name$="-swatch"]';
      }

      connectedCallback() {
        try {
          this._labelEl = this.querySelector(this._LABEL_SELECTOR);
          this._picker = this.querySelector(this._PICKER_SELECTOR);
          if (!this._labelEl || !this._picker) return;

          this.addEventListener('change', this._onChange, { passive: true });
          this.addEventListener('variant:update', this._onVariantEvent);
          this.addEventListener('variant:selected', this._onVariantEvent);
          this._updateSelectedLabel();
        } catch (e) {
          console.error('product-swatches-content init error', e);
        }
      }

      disconnectedCallback() {
        try {
          this.removeEventListener('change', this._onChange);
          this.removeEventListener('variant:update', this._onVariantEvent);
          this.removeEventListener('variant:selected', this._onVariantEvent);
        } catch (e) {
          console.error('product-swatches-content disconnect error', e);
        }
      }

      _onChange(event) {
        const target = event.target;
        if (target && target.matches(this._SWATCH_INPUT_MATCH)) {
          this._updateSelectedLabel();
        }
      }

      _onVariantEvent() {
        this._updateSelectedLabel();
      }

      _updateSelectedLabel() {
        if (!this._picker || !this._labelEl) return;
        const checked = this._picker.querySelector(this._CHECKED_INPUT_SELECTOR);
        if (checked instanceof HTMLInputElement) {
          const name = checked.getAttribute('aria-label') || checked.value || '';
          const valueEl = this._labelEl.querySelector('[data-selected-swatch-value]');
          if (valueEl) { valueEl.textContent = name; } else { this._labelEl.textContent = name ? name + ':' : ''; }
        }
      }
    }

    customElements.define('product-swatches-content', ProductSwatchesContent);
  }
  } catch(e) { console.error(e); }
})();

})();
